import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import RadioButton from "../../../components/common/Radio_button";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import Input from "../../../components/common/Input";
import LeftBase from "../../../components/common/LeftBase";
import Select from "../../../components/common/Select";
import Logo from "../../../components/logo/Logo";
import SocialLogin from "../../../components/socialLogin/SocialLogin";
import { OnResendOtp, VerifyVendorEmail } from "../verifyEmail/queries";
import { phoneField, titleOptionsNew } from "../../../constants";
import loginFooter from "../../../assets/assets_html/images/login-footer-icon.png";
import mobileRegister from "../../../assets/assets_html/images/mobile.png";
import emailRegister from "../../../assets/assets_html/images/emailid.png";
import firstNameRegister from "../../../assets/assets_html/images/firstname.png";
import passwordRegister from "../../../assets/assets_html/images/password.png";
import axios from "axios";
import {
  SET_LOGIN_USER_SUCCESS,
  SET_TOKEN_ON_REGISTRATION,
} from "../../../store/actions/loginActions";
import { Modal } from "react-bootstrap";



import { registerNewUser } from "../../../store/apiCalls/authentication";
import {
  handleShowPassword,
  invalidAccess,
  validateEmail,
  validatePassword,
  validatePhoneNumber,
} from "../../../utils";
import { OnSocialLogin } from "../login/queries";
import "./index.scss";
import "./index.css";
import active_eye from "../../../svg/active-eye.svg";
import user_solid from "../../../svg/user_solid.svg";
import email_solid from "../../../svg/email_solid.svg";
import phone_solid from "../../../svg/phone_solid.svg";
import lock_solid from "../../../svg/lock_solid.svg";
import active_email from "../../../svg/active-email.svg";
import active_lock from "../../../svg/active-lock.svg";
import disable_eye from "../../../svg/disable-eye.svg";
import disable_email from "../../../svg/disable-email.svg";
import disable_lock from "../../../svg/disable-lock.svg";
import disable_phone from "../../../svg/disable-phone.svg";
import active_phone from "../../../svg/active-phone.svg";
import active_info from "../../../svg/active-info.svg";
import active_promo from "../../../svg/active_promo.svg";
import disable_promo from "../../../svg/disable_promo.svg";
import user_icon from "../../../assets/img/icons/profile.svg";
import VikramshilaLogo from "../../../assets/img/logos/logo_full_org.svg";
import Divider from "../../../components/common/Divider";
import Checkbox from "../../../components/common/Checkbox";
import FormModal from "../../../components/Modal/formModal";
import SuccessModal from "../../../components/Modal/sucessModal";
import VerifyOtp from "../verifyotp";
import verifiedIcon from "../../../svg/verifiedCheck.svg";
import TermsModal from "../../../components/Modal/TermsModal";
import PrivacyPolicyModal from "../../../components/Modal/PrivacyPolicyModal";
import { Helmet } from "react-helmet";
import AakashgangaHeader from "../../../components/global/HeaderComponent";
function Registration() {
  const [registrationData, setRegistrationData] = useState({
    fullName: "",
    nationality: "withInIndia",
    referralCode:
      new URLSearchParams(window.location.search).get("promo") || "",
  });

  console.log("registrationData", registrationData);
  const [registeredModal, setRegisteredModal] = useState({
    show: false,
    published: false,
  });
  const [otp, setOtp] = useState();
  const [errorMsg, setErrorMsg] = useState("");
  const [datacountry, setdatacountry] = useState("");
  const [fullNameNew, setFullNameNew] = useState();
  const [mobileOtp, setMobileotp] = useState();
  const [userId, setUserId] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [VerifyPopupOpen, setVerifyPopupOpen] = useState(false);
  const [VerifyMobilePopupOpen, setVerifyMobilePopupOpen] = useState(false);
  const [openSucessModal, setOpenSucessModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    policyCheck: false,
    signupForUpdates: false,
  });
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });

  const [disabled, setDisabled] = useState(true);
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Accessing UTM parameters
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign");
  const utmContent = searchParams.get("utm_content");

  // Capture invite token from URL (sent when external peer reviewer registers via invite link)
  const inviteToken = searchParams.get("token") || "";

  const sucessHandler = (sucess) => {
    setErrorMsg("");
    setUserId(sucess?.data?.userId);

    // comment code in production
    // setMobileotp(sucess?.data?.otpForMobileVerification);
    setMobileotp("");
    setToken(sucess?.data?.token);
    // uncomment code in production
    if (registrationData.nationality === "withInIndia") {
      setVerifyMobilePopupOpen(true);
    } else {
      setVerifyMobilePopupOpen(false);
      setVerifyPopupOpen(true);
    }
  };

  const EmailsucessHandler = (sucess) => {
    setErrorMsg("");
    setVerifyPopupOpen(false);
    setOpenSucessModal(true);
  };

  const MobilesucessHandler = (sucess) => {
    setMobileotp();
    setErrorMsg("");
    setOtp();
    setVerifyMobilePopupOpen(false);
    setVerifyPopupOpen(true);
  };

  const handleHome = (e) => {
    e.preventDefault();
    navigate(registeredModal.published ? "/" : "/login");
    setRegisteredModal({ show: false, published: false });
  };

  const handleRedirectVideo = (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    window.open("https://youtu.be/sySB0yvpqE8", "_blank");
  };

  const handleAcceptTermsClose = () => {
    setCheckboxes({ ...checkboxes, policyCheck: true });
    setShowTermsModal(false);
  };

  const handleTermsClose = () => {
    setShowTermsModal(false);
  };

  const handleAcceptPrivacyClose = () => {
    setCheckboxes({ ...checkboxes, policyCheck: true });
    setShowPrivacyModal(false);
  };

  const handlePrivacyClose = () => {
    setShowPrivacyModal(false);
  };

  const handleVerifyEmailSubmit = (e) => {
    e.preventDefault();
    const headers = {
      otp: otp,
      userId: userId,
    };
    verifyEmail(headers);
  };

  const handleVerifyMobileSubmit = (e) => {
    e.preventDefault();
    const headers = {
      otpForMobileVerification: mobileOtp,
      userId: userId,
    };
    verifyMobile(headers);
  };
  const resendOtpSucess = (sucess) => {
    setErrorMsg("");
    // comment code in production
    if (sucess?.data?.otpformobileverification) {
      // setMobileotp(sucess?.data?.otpformobileverification);
      setMobileotp("");
    }
  };
  const handleRensedOtp = (e, type) => {
    e.preventDefault();
    if (type === "email") {
      let param = {
        email: registrationData?.email,
      };
      resedOtp(param);
    } else {
      let param = {
        phoneNumber: registrationData?.phoneNumber,
      };
      resedOtp(param);
    }
  };

  const { mutate: resedOtp } = OnResendOtp(resendOtpSucess, setErrorMsg);
  const { mutate: verifyEmail } = VerifyVendorEmail(
    EmailsucessHandler,
    setErrorMsg,
  );
  const { mutate: verifyMobile } = VerifyVendorEmail(
    MobilesucessHandler,
    setErrorMsg,
  );

  const socialSucessHandler = (success) => {
    setErrorMsg("");
    if (success?.data?.isSetupProfile) {
      localStorage.setItem("usertoken", success.data?.token);
      storeSessionTime();
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: success?.data,
      });
      navigate("/dashboard");
      return null;
    } else {
      setRegisteredModal({
        show: true,
        published: success?.data?.isSetupProfile ? true : false,
      });
    }
  };

  const { mutate: socialLogin } = OnSocialLogin(socialSucessHandler);
  const handleClickCheckbox = (e, type) => {
    const { name, checked } = e.target;
    return setCheckboxes({ ...checkboxes, [name]: checked });
  };

  const handleSocialLogin = (result) => {
    const data = result?.user;

    const apiBody = {
      fullName: data?.displayName,
      email:
        result?.providerId === "twitter.com"
          ? result?.["_tokenResponse"]?.email
          : data?.email,
      rawId: data?.uid,
      isSocialLogin: true,
      signupForUpdates: checkboxes?.signupForUpdates || false,
      utmSource: utmSource,
      utmMedium: utmMedium,
      utmCampaign: utmCampaign,
      utmContent: utmContent,
    };

    socialLogin(apiBody);
  };
  function trimSpaces(str) {
    return str ? str.trim() : str;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (registrationData?.password !== registrationData?.confirmPassword) {
      return setErrorMsg("Password and confirm password do not match.");
    }

    const formdata = new FormData();
    for (let key in registrationData) {
      formdata.append(key, trimSpaces(registrationData[key]));
    }

    formdata.append("signupForUpdates", checkboxes?.signupForUpdates);
    formdata.append("policyCheck", checkboxes?.policyCheck);

    // Append the invite token if present (links registration to the editor's invite)
    if (inviteToken) {
      formdata.append("token", inviteToken);
    }

    dispatch({ type: "SET_LOADER", payload: true });
    const submitResp = await registerNewUser(formdata);
    dispatch({ type: "SET_LOADER", payload: false });
    if (submitResp?.data?.success) {
      sucessHandler(submitResp);
    } else if (submitResp?.response?.status === 400) {
      let error = { message: submitResp.response.data.message };
      if (submitResp.response.status === 412) {
        error = {
          message:
            submitResp.response.data.message +
            " " +
            submitResp.response.data.data.errors.password[0],
        };
      }

      if (submitResp?.response?.data?.emailAreadyRegistered) {
        setRegisteredModal({
          show: true,
          published: submitResp?.response?.data?.isSetupProfile ? true : false,
        });
      }
      setErrorMsg(error?.message);
    } else {
      setRegisteredModal({ show: false, published: false });
      setErrorMsg(error?.message);
    }
    return null;
  };

  const handleSelectChange = (value, type) => {
    return setRegistrationData({ ...registrationData, [type]: value });
  };

  if (!utmSource) {
    var allutm = "";
  } else {
    var allutm = `?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&utm_content=${utmContent}`;
  }
  const capitalizeFirstLetter = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const handleFullnameChange = (e) => {
    const { value, name } = e.target;
    const capitalizedValue = capitalizeFirstLetter(value); // Capitalize input

    if (name === "first") {
      setFirstName(capitalizedValue);
      setRegistrationData((prevData) => ({
        ...prevData,
        fullName: `${capitalizedValue} ${lastName}`, // Use new first name
      }));
    } else if (name === "last") {
      setLastName(capitalizedValue);
      setRegistrationData((prevData) => ({
        ...prevData,
        fullName: `${firstName} ${capitalizedValue}`, // Use new last name
      }));
    }
  };

  function getWordAtIndex(str, index) {
    let words = str?.split(" ");
    return words?.[index] || "";
  }
  const handleChange = (e) => {
    const { value, name } = e.target;

    if (name === phoneField) {
      return setRegistrationData({
        ...registrationData,
        [name]: validatePhoneNumber(value),
        utmSource: utmSource,
        utmMedium: utmMedium,
        utmCampaign: utmCampaign,
        utmContent: utmContent,
      });
    }

    return setRegistrationData({
      ...registrationData,
      [name]: invalidAccess(value),
    });
  };
  const handleSuccessModalSubmit = () => {
    setOpenSucessModal(false);
    localStorage.setItem("usertoken", token);
    storeSessionTime();
    dispatch({
      type: SET_TOKEN_ON_REGISTRATION,
      payload: { token: token, _id: userId },
    });
  };

  const handleRedirect = (e, path = "/") => {
    e.preventDefault();
    navigate(path);
  };

  const handleHide = (e) => {
    setRegisteredModal({ show: false, published: false });
  };

  const handleChatBot = (e) => {
    e.preventDefault();
    window.zE("messenger", "open");
  };
  const getGeoInfo = () => {
    axios
      .get("http://ip-api.com/json")
      .then((response) => {
        let data = response.data;
        // setdatacountry(data?.country_name);
        // console.log(data?.country);
        if (data?.country != "India") {
          setRegistrationData({
            ...registrationData,
            nationality: "outSideIndia",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getGeoInfo();
  }, []);

  useEffect(() => {
    setDisabled(
      !(
        firstName &&
        lastName &&
        validateEmail(registrationData?.email) &&
        (registrationData.nationality === "withInIndia"
          ? registrationData?.phoneNumber?.length === 10
          : true) &&
        registrationData?.title &&
        validatePassword(registrationData?.password) &&
        registrationData?.confirmPassword &&
        checkboxes?.policyCheck
      ),
    );
  }, [registrationData, checkboxes]);
  function storeSessionTime() {
    const addedMin = 420;
    const miliseconds = new Date().getTime() + addedMin * 60000;
    localStorage.setItem("tokenExpireTime", miliseconds);
  }
  const handleNationalityChange = (e) => {
    setRegistrationData({
      ...registrationData,
      nationality: e.target.id,
    });
  };

  return (
    <>
      <AakashgangaHeader />
      <div className="container-flex register-page">
        <Helmet>
          <title>Registration | Aakashganga open</title>
          <meta
            name="description"
            content="Join Aakash Ganga Open today and unlock a world of publishing opportunities. Register now to start your journey"
          />

          <meta
            property="og:title"
            content="Registration | Aakashganga open"
            data-react-helmet="true"
          />
          <meta
            property="og:description"
            content="Join Aakash Ganga Open today and unlock a world of publishing opportunities. Register now to start your journey"
            data-react-helmet="true"
          />
          <meta
            property="og:url"
            content="https://www.aakashgangaopen.in/registration"
            data-react-helmet="true"
          />

          <link
            rel="canonical"
            href="https://www.aakashgangaopen.in/registration"
            data-react-helmet="true"
          />
        </Helmet>
        <div className="row h-100">
          <div className="col-lg-5 col-xl-5 left-base position-relative">
            <LeftBase type="Login" />
          </div>
          <div
            className="col-lg-7 col-xl-7 col-md-12 col-sm-12 m-auto register-form-column"
          >
            <div className="p-3">
              <div
                className="d-flex justify-content-between align-items-center mt-3"
                style={{
                  width: "80%",
                  margin: "auto",
                  marginTop: "50px !important"
                }}
              >
                <h1 className="fw-bold mb-0" style={{ fontSize: "2.5rem" }}>
                  Begin Your Registration
                </h1>
                <div className="loginMember text-nowrap d-flex justify-content-between align-items-center">
                  <span className="labelColor" style={{ fontSize: "1.1rem" }}>
                    Already have an account?{" "}
                  </span>

                  <Link
                    to={`/login${allutm}`}
                    className="link ms-1 fw-bold text-uppercase"
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      textDecoration: "underline",
                      color: "#006f92",
                    }}
                  >
                    LOGIN NOW
                  </Link>
                </div>
              </div>

              <div className="frame m-auto">
                <Form onSubmit={handleSubmit}>
                  <div className="form-group mb-2 d-flex ps-10 country-select">
                    {true ? null : (
                      <>
                        <RadioButton
                          label="Within India"
                          name="nationality"
                          id="withInIndia"
                          labelClass={
                            registrationData.nationality === "withInIndia"
                              ? "form-check-label"
                              : "form-check-label disable"
                          }
                          checked={
                            registrationData.nationality === "withInIndia"
                          }
                          handleChange={handleNationalityChange}
                          required
                        />

                        <RadioButton
                          label="Outside India"
                          name="nationality"
                          id="outSideIndia"
                          labelClass={
                            registrationData.nationality === "outSideIndia"
                              ? "form-check-label"
                              : "form-check-label disable"
                          }
                          checked={
                            registrationData.nationality === "outSideIndia"
                          }
                          handleChange={handleNationalityChange}
                          required
                        />
                      </>
                    )}
                  </div>
                  <div class="title_with_name d-flex flex-column flex-md-row align-items-md-baseline mb-2">
                    <div className="w-100 me-2" style={{ maxWidth: "140px" }}>
                      <div class="w-100 position-relative">
                        <span
                          style={{
                            position: "absolute",
                            top: "-11px",
                            left: "16px",
                            zIndex: 10,
                            fontSize: "16px",
                            background: "white",
                            fontWeight: 700,
                            padding: "0 8px",
                            color: "#404040",
                          }}
                        >
                          Title
                        </span>
                        <Select
                          handleChange={(value) =>
                            handleSelectChange(value, "title")
                          }
                          selectedValue={registrationData.title}
                          options={titleOptionsNew?.map((val) => val?.key)}
                          optionValues={titleOptionsNew?.map(
                            (val) => val?.value,
                          )}
                          labelClass={"hidden"}
                          placeholder="Select"
                          name="title"
                        />
                        <span
                          className="mandatory-asterisk"
                          style={{
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)",
                            left: "8px",
                            color: "#dc3545",
                            fontSize: "16px",
                            fontWeight: 700,
                            zIndex: 2,
                          }}
                        >
                          *
                        </span>
                      </div>
                    </div>
                    <div className="w-100 me-2 firstname-slot">
                      <Input
                        name="first"
                        className={
                          firstName
                            ? "form-control active-input with_icon"
                            : "form-control grey-input with_icon"
                        }
                        handleChange={handleFullnameChange}
                        type="text"
                        mandatory={true}
                        preIconClass={user_solid}
                        labelClass={""}
                        label="First Name"
                        placeholder=""
                        value={firstName}
                      />
                    </div>
                    <div className="w-100 lastname-slot">
                      <Input
                        name="last"
                        className={
                          lastName
                            ? "form-control active-input with_icon"
                            : "form-control grey-input with_icon"
                        }
                        handleChange={handleFullnameChange}
                        type="text"
                        mandatory={true}
                        preIconClass={user_solid}
                        labelClass={""}
                        label="Last Name"
                        placeholder=""
                        value={lastName}
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row align-items-md-baseline mb-2">
                    <div className="w-100 me-2">
                      <Input
                        name="email"
                        handleChange={handleChange}
                        type="email"
                        className={
                          registrationData?.email
                            ? "form-control active-input with_icon"
                            : "form-control grey-input with_icon"
                        }
                        preIconClass={
                          registrationData?.email
                            ? emailRegister
                            : emailRegister
                        }
                        mandatory={true}
                        labelClass={""}
                        label="Email ID"
                        placeholder="Email ID"
                        value={registrationData.email}
                      />
                    </div>
                    <div className="w-100">
                      {registrationData.nationality !== "outSideIndia" && (
                        <div className="position-relative">
                          <span
                            className={
                              registrationData?.phoneNumber
                                ? "tel-active"
                                : "tel-disable"
                            }
                          ></span>
                          <Input
                            type="tel"
                            maxLength={10}
                            name="phoneNumber"
                            className={
                              registrationData?.phoneNumber
                                ? "form-control active-input tel-pd with_icon"
                                : "form-control grey-input tel-pd with_icon"
                            }
                            preIconClass={
                              registrationData?.phoneNumber
                                ? mobileRegister
                                : mobileRegister
                            }
                            mandatory={true}
                            handleChange={handleChange}
                            labelClass={""}
                            value={registrationData.phoneNumber}
                            label="Mobile Number"
                            placeholder="xxxxxxxxxx"
                          />
                        </div>
                      )}
                      {registrationData.nationality === "outSideIndia" && (
                        <div style={{ height: "48px", width: "100%" }}></div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row align-items-md-baseline mb-2">
                    <div className="w-100 me-2">
                      <Input
                        name="password"
                        handleChange={handleChange}
                        type={!showPassword?.password ? "password" : "text"}
                        className={
                          registrationData?.password
                            ? "form-control active-input with_icon"
                            : "form-control grey-input with_icon"
                        }
                        preIconClass={
                          registrationData?.password
                            ? passwordRegister
                            : passwordRegister
                        }
                        postIconClass={
                          registrationData?.password ? active_eye : disable_eye
                        }
                        mandatory={true}
                        labelClass={""}
                        value={registrationData.password}
                        placeholder="Password"
                        label="Password"
                        labelIcon={active_info}
                        title="Password should be of 8 character with one number, one capital letter and a special character."
                        onIconClick={() =>
                          handleShowPassword(
                            setShowPassword,
                            showPassword,
                            "password",
                          )
                        }
                      />
                    </div>
                    <div className="w-100">
                      <Input
                        name="confirmPassword"
                        handleChange={handleChange}
                        type={
                          !showPassword?.confirmPassword ? "password" : "text"
                        }
                        className={
                          registrationData?.confirmPassword
                            ? "form-control active-input with_icon"
                            : "form-control grey-input with_icon"
                        }
                        preIconClass={
                          registrationData?.confirmPassword
                            ? passwordRegister
                            : passwordRegister
                        }
                        postIconClass={
                          registrationData?.confirmPassword
                            ? active_eye
                            : disable_eye
                        }
                        mandatory={true}
                        labelClass={""}
                        value={registrationData.confirmPassword}
                        placeholder="Confirm Password"
                        label="Confirm Password"
                        title="Password should be of 8 character with one number, one capital letter and a special character."
                        onIconClick={() =>
                          handleShowPassword(
                            setShowPassword,
                            showPassword,
                            "confirmPassword",
                          )
                        }
                      />
                    </div>
                  </div>

                  <div className="position-relative promo">
                    <Input
                      errors={errorMsg}
                      type="text"
                      name="referralCode"
                      preIconClass={
                        registrationData?.referralCode
                          ? active_promo
                          : disable_promo
                      }
                      handleChange={handleChange}
                      value={
                        registrationData?.referralCode
                          ? registrationData?.referralCode
                          : ""
                      }
                      placeholder="If any"
                      className={
                        registrationData?.referralCode
                          ? "form-control with_icon active-input"
                          : "form-control with_icon grey-input"
                      }
                      labelClass={""}
                      label="Referral Code"
                      optionLabel={true}
                      showOptionalIcon={!registrationData?.referralCode}
                    />
                  </div>

                  <div
                    className="d-flex justify-content-between align-items-center pt-2"
                  >
                    <div className="d-flex align-items-start">
                      <Checkbox
                        onRadioChange={handleClickCheckbox}
                        name="policyCheck"
                        checked={checkboxes?.policyCheck}
                        className="form-check-input me-2 mt-1"
                        style={{ width: "25px", height: "25px", flexShrink: 0, backgroundColor: "#006f92" }}
                      />
                      <span className="small labelColor" style={{ lineHeight: "1.4" }}>
                        <span className="labelColor">
                          I agree with Vikramshila's{" "}
                        </span>
                        <TermsModal
                          showTermsModal={showTermsModal}
                          handleTermsClose={handleTermsClose}
                          handleAcceptTermsClose={handleAcceptTermsClose}
                        />
                        <Link
                          href="#"
                          onClick={() => setShowTermsModal(true)}
                          className="link"
                          style={{
                            color: "#006f92",
                            paddingLeft: "7px",
                          }}
                        >
                          {" "}
                          Terms of Service
                        </Link>{" "}
                        <span
                          className="labelColor"
                          style={{ paddingLeft: "7px" }}
                        >
                          and{" "}
                        </span>
                        <PrivacyPolicyModal
                          showPrivacyModal={showPrivacyModal}
                          handlePrivacyClose={handlePrivacyClose}
                          handleAcceptPrivacyClose={handleAcceptPrivacyClose}
                        />{" "}
                        <Link
                          href="#"
                          onClick={(e) => setShowPrivacyModal(true)}
                          className="link"
                          style={{
                            color: "#006f92",
                            paddingLeft: "7px",
                          }}
                        >
                          {" "}
                          Privacy Policy{" "}
                        </Link>
                      </span>
                    </div>
                    <span className="small labelColor">
                      <span style={{ color: "#dc3545" }}>*</span> Mandatory
                    </span>
                  </div>

                  <div className="py-1 w-100 mt-2">
                    <div className="d-flex align-items-start">
                      <Checkbox
                        name="signupForUpdates"
                        checked={checkboxes?.signupForUpdates}
                        className="form-check-input me-2 mt-1"
                        style={{ width: "25px", height: "25px", flexShrink: 0 }}
                        onRadioChange={handleClickCheckbox}
                      />
                      <span className="labelColor" style={{ fontSize: "16px" }}>
                        Sign me up for more information and updates.
                      </span>
                    </div>
                  </div>

                  <div className="mb-4 mt-5 text-center">
                    <Button
                      className="btnActive"
                      type="submit"
                      title="START YOUR SUBMISSION"
                    />
                  </div>
                  {/* <div
                    style={{
                      position: "fixed",
                      bottom: "50px",
                      right: "50px",
                    }}
                  >
                    <img src={loginFooter} alt="login" />
                  </div> */}
                </Form>
              </div>
            </div>
          </div>

          {registrationData?.nationality === "withInIndia" ? (
            <FormModal
              className="verified-mobile_popup static-modal"
              handleClose={(e) => setVerifyMobilePopupOpen(false)}
              errorMsg={errorMsg}
              show={VerifyMobilePopupOpen}
              closebutton={true}
              informationText="Please enter the OTP sent to your mobile number"
              modalHeading="Verify Mobile Number"
            >
              <VerifyOtp
                handleRensedOtp={handleRensedOtp}
                otp={mobileOtp}
                setOtp={setMobileotp}
                handleSubmit={handleVerifyMobileSubmit}
                type="mobile"
              />
            </FormModal>
          ) : null}

          {registrationData?.nationality === "withInIndia" ? (
            <FormModal
              show={VerifyPopupOpen}
              size="sm"
              closebutton={true}
              handleClose={(e) => setVerifyPopupOpen(false)}
              upperInformationText={`Your mobile number has been successfully verified <img src=${verifiedIcon} alt="mobile" class="mx-1 mb-1" />`}
              lowerInformationText="Please enter the OTP sent to your email ID"
              modalHeading="Verify Email ID"
            >
              <VerifyOtp
                errorMsg={errorMsg}
                handleRensedOtp={handleRensedOtp}
                otp={otp}
                setOtp={setOtp}
                handleSubmit={handleVerifyEmailSubmit}
                type="email"
              />
            </FormModal>
          ) : (
            <FormModal
              show={VerifyPopupOpen}
              size="sm"
              closebutton={true}
              handleClose={(e) => setVerifyPopupOpen(false)}
              lowerInformationText="Please enter the OTP sent to your email ID"
              modalHeading="Verify Email ID"
            >
              <VerifyOtp
                errorMsg={errorMsg}
                handleRensedOtp={handleRensedOtp}
                otp={otp}
                setOtp={setOtp}
                handleSubmit={handleVerifyEmailSubmit}
                type="email"
              />
            </FormModal>
          )}

          <Modal
            show={registeredModal.show}
            onHide={handleHide}
            className="re-register justify-content-center pb-3 px-0 pt-0"
            centered
          >
            <Modal.Header className="justify-content-center px-0 pt-0">
              <Modal.Title>
                <div className="big-heading error-title">
                  YOU ARE ALREADY REGISTERED
                </div>
              </Modal.Title>
              <button
                type="button"
                className="btn-close"
                onClick={(e) => handleHide()}
                aria-label="Close"
              />
            </Modal.Header>

            <div
              className="text-center label-info f-700 color-black"
              dangerouslySetInnerHTML={{
                __html: "We will get in touch with you soon...",
              }}
            />
            <div
              className="text-center label-info mt-3 color-black f-size-16"
              dangerouslySetInnerHTML={{
                __html: "Till then, we welcome you to listen to",
              }}
            />

            <Modal.Footer className="justify-content-center d-grid">
              <Button
                handleClick={(e) => handleRedirectVideo(e)}
                title="MESSAGE FROM THE FOUNDER"
                type="button"
              />
              <div className="text-center">
                <a
                  onClick={(e) => handleHome(e)}
                  href="/"
                  className="link text-decoration-none f-700"
                >
                  {registeredModal.published
                    ? "HOME"
                    : "Complete Profile Setup"}
                </a>
              </div>
            </Modal.Footer>
          </Modal>

          <SuccessModal
            size="md"
            bigHeading="CONGRATULATIONS!"
            upperInformationText={
              registrationData?.nationality === "withInIndia"
                ? `Mobile number verified <img src=${verifiedIcon} alt="email" className="mx-1" /> Email ID verified <img src=${verifiedIcon} alt="email" className="mx-1" />`
                : `Email ID verified <img src=${verifiedIcon} alt="email" className="mx-1" />`
            }
            lowerInformationText={`Please set up your profile to continue <br /><br /> <span style="font-size: 14px; text-align: center; display: block;">Complete your registration to earn 500 Mudras (INR) in your Aakashganga account. Use it as a code when writing your paper.</span>`}
            show={openSucessModal}
            onSubmit={() => {
              handleSuccessModalSubmit();
            }}
            submitButtonTitle="COMPLETE YOUR REGISTRATION"
          />
        </div>
        <img
          src="/assets/images/cookie-logo.png"
          alt="cookie"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "40px",
            height: "40px",
            zIndex: 1000,
          }}
        />
      </div>
    </>
  );
}

export default Registration;
